const RelationNames = Object.freeze({
  EMPLOYERS: 'employers',
  EMPLOYEES: 'employees',
  HOUSEHOLD: 'household',
  AFFILIATIONS: 'affiliations',
  CONNECTIONS: 'connections',
});

export default RelationNames;
